import React from "react";
import { MenuItem, Select } from "@material-ui/core";
// import { SelectInputProps } from "@material-ui/core/Select/SelectInput";

type Options = {
  value?: string;
  name?: string;
};
type Props = {
  value: string;
  options: Options[];
  // value: any;
  onChange: any;
};
export default function SelectInput(props: Props) {
  const { options, value, onChange } = props;

  console.log("SelectInput:", options, value);

  return (
    <>
      {options && (
        <Select
          displayEmpty
          value={value ?? ""}
          onChange={(event) => onChange(event.target.value)}
        >
          {/* <MenuItem value="">選択してください</MenuItem> */}

          {options.map((item, index) => {
            return (
              <MenuItem value={item.value} key={index}>
                {item.name}
              </MenuItem>
            );
          })}
        </Select>
      )}
    </>
  );
}
